module.exports = __webpack_public_path__ + "img/first-slide-hello.1518aba.png?v=1763034624171";